import { Module } from "src/state/Module"
import * as Types from "src/state/gql/_types"

export const ThreadModule = new Module<Types.ThreadFragment, Types.GetThreadsQueryVariables, Types.Threads_Insert_Input>({
    orderBy: {
        'updated_at': 'desc'
    }
})